export default {
  getTextWidth(text) {
    var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = 'bold 14pt arial';
    var metrics = context.measureText(text);
    return metrics.width;
  },
  insertAt(string, position, value) {
    return [string.slice(0, position), value, string.slice(position)].join('');
  },
  moveCursorToEnd(target) {
    const value = $(target).val();
    $(target).focus().val('').val(value);
  },
  validateEmail(email) {
    if (!email) return true;

    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  validateSpacesOnString(string) {
    if (!string) return false;
    return /^\S*$/.test(String(string).toLowerCase());
  },
  maskCep(cep) {
    if (cep) cep = cep.replace('-', '').replace(/^(\d{5})(\d{3}).*/, '$1-$2');
    return cep;
  },
};
